import api from "../../Api/feathers-client";
import { find, maxBy, sortBy } from "lodash";
import {
  getResumeAssignmentData,
  getSpecialAssessmentLog,
  getTasksData,
} from "./Services";

export const AssignmentIsOpen = async (
  filter,
  assignmentname,
  userInfo,
  clickedAssignment
) => {
  return new Promise(async (resolve, reject) => {
    let taskData = await getTasksData(
      clickedAssignment.tasks.tasks[0],
      userInfo.site_uuid
    );

    let specialExamLogRes = await getSpecialAssessmentLog(
      userInfo.uid,
      userInfo.site_uuid,
    );
    console.log("specialExamLogRes",specialExamLogRes);
    if (specialExamLogRes?.data?.data.length > 0) {
      if (taskData.data[0]["tags"]["tags"].indexOf("Special Assessment") > -1) {
        resolve({
          message: "New Assignment open",
          status: true,
        });
      } else {
        if (filter == "finished" && clickedAssignment.is_exam) {
          resolve({
            message: "You are only permitted to take the E-exam once.",
            status: false,
          });
        }
        console.log("ADD", clickedAssignment);
        let assignment = await getAssignment({
          title: assignmentname.toString(),
          site_uuid: userInfo.site_uuid,
          is_deleted: false,
          created_by: clickedAssignment.created_by,
        });
        assignment = assignment["data"][0];
        console.log("assignment", assignment);
        if (filter == "new") {
          let minimumonelog = await getOneRatingAssignmentLog({
            target: assignment.uid,
            actor: userInfo.uid,
            site_uuid: userInfo.site_uuid,
            verb: "ratingAssignment",
          });

          if (assignment.is_exam) {
            resolve({
              message: "Last assignment is e-exam",
              status: true,
            });
          } else {
            if (minimumonelog?.data?.data?.length == 0) {
              resolve({
                message: "Last assignment was not completed atleast once.",
                status: false,
              });
            } else {
              resolve({
                message: "Last assignment is completed.",
                status: true,
              });
            }
            // let attempts = await checkMultiAttemptWithPercent(
            //   assignment.uid,
            //   userInfo.uid,
            //   userInfo.site_uuid,
            //   filter
            // );
            // resolve(attempts);
          }
        } else {
          // let attempts = await checkMultiAttemptWithPercent(
          //   assignment.uid,
          //   userInfo.uid,
          //   userInfo.site_uuid,
          //   filter
          // );
          // resolve(attempts);
          resolve({
            message: "New Assignment open",
            status: true,
          });
        }
      }
    } else {
      if (taskData.data[0]["tags"]["tags"].indexOf("Special Assessment") > -1) {
        resolve({
          message: "New Assignment open",
          status: true,
        });
      } else {
        resolve({
          message: "Please attempt the assessment first.",
          status: false,
        });
      }
    }
  });
};

const checkMultiAttemptWithPercent = async (
  assignmentid,
  user_id,
  site_uuid,
  filter
) => {
  return new Promise(async (resolve, reject) => {
    let attemptCount = await getSummaryLog({
      target: assignmentid,
      actor: user_id,
      site_uuid: site_uuid,
    });
    let lastRecord = maxBy(attemptCount?.data?.data, "id");
    if (
      attemptCount?.data?.total <
      Number(process.env.REACT_APP_SELF_LEARN_MAX_ATTEMPT)
    ) {
      let lastRecord = maxBy(attemptCount?.data?.data, "id");
      if (lastRecord) {
        let totalAssets = lastRecord.outcome?.totalAssets;
        let attemptedAssets = lastRecord.outcome?.attemptedAssets;
        let score = lastRecord.outcome?.score;
        if (filter == "new" && attemptedAssets < totalAssets) {
          resolve({
            message: "Last assignment not completed",
            status: false,
          });
        } else {
          let percent = ((score / totalAssets) * 100).toFixed(1);
          if (
            Number(percent) <
            Number(process.env.REACT_APP_SELF_LEARN_PERCENT_FOR_PASS)
          ) {
            if (filter == "new") {
              resolve({
                message: `Last assignment not completed with ${process.env.REACT_APP_SELF_LEARN_PERCENT_FOR_PASS}`,
                status: false,
              });
            } else {
              resolve({
                message: `Last assignment not completed with ${process.env.REACT_APP_SELF_LEARN_PERCENT_FOR_PASS} from complete`,
                status: true,
              });
            }
          } else {
            if (filter == "new") {
              resolve({
                message: `Last assignment not completed with ${process.env.REACT_APP_SELF_LEARN_PERCENT_FOR_PASS}`,
                status: true,
              });
            } else {
              resolve({
                message: `Last assignment completed with ${process.env.REACT_APP_SELF_LEARN_PERCENT_FOR_PASS}`,
                status: false,
              });
            }
          }
        }
      }
    } else {
      let totalAssets = lastRecord.outcome?.totalAssets;
      let attemptedAssets = lastRecord.outcome?.attemptedAssets;
      if (filter == "new") {
        if (attemptedAssets == totalAssets) {
          resolve({
            message: `Assignment ${process.env.REACT_APP_SELF_LEARN_MAX_ATTEMPT} attempts completed`,
            status: true,
          });
        } else {
          resolve({
            message: `Last assignment not attempted`,
            status: false,
          });
        }
      } else {
        if (attemptedAssets < totalAssets) {
          resolve({
            message: `Assignment ${process.env.REACT_APP_SELF_LEARN_MAX_ATTEMPT}rd attempt is pending`,
            status: true,
          });
        } else {
          resolve({
            message: `Assignment ${process.env.REACT_APP_SELF_LEARN_MAX_ATTEMPT} attempts completed`,
            status: false,
          });
        }
      }
    }
  });
};

// Call backend service to get selected assignment
export const getAssignment = async (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find({
        query,
      });

      resolve({
        status: 200,
        message: "All Assignments",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getSummaryLog = async (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignment-summary-logs").find({
        query,
      });

      resolve({
        status: 200,
        message: "Summary Logs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getOneRatingAssignmentLog = async (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query,
      });

      resolve({
        status: 200,
        message: "Summary Logs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
